import { render, staticRenderFns } from "./marks_sms.vue?vue&type=template&id=6693e54a&"
import script from "./marks_sms.vue?vue&type=script&lang=js&"
export * from "./marks_sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports